"use client";

import { useEffect } from "react";
import HeroSection from "./sections/HeroSection";
import TrustBar from "./sections/TrustBar";
import MethodSection from "./sections/MethodSection";
import WorkflowShowcase from "./sections/WorkflowShowcase";
import PhilosophySection from "./sections/PhilosophySection";
import FAQSection from "./sections/FAQSection";
import CTAFooterWrapper, { CTABlock } from "./sections/CTAFooterWrapper";

export default function Landing2Page() {
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href^="#"]');
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (href && href !== "#") {
          e.preventDefault();
          const element = document.querySelector(href);
          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);

  return (
    <div
      className="landing-page min-h-screen text-white relative overflow-x-hidden"
      style={{ backgroundColor: "#0E0E0E" }}
    >
      <main className="relative z-10">
        <HeroSection />
        <TrustBar />
        <MethodSection />
        <WorkflowShowcase />
        <PhilosophySection />
        <CTABlock />
        <FAQSection />
        <CTAFooterWrapper />
      </main>
    </div>
  );
}
